function runClientsMarquee() {
  if (typeof window.NMHomeContent?.initClientsMarquee === "function") {
    window.NMHomeContent.initClientsMarquee();
    return;
  }

  const clientsBlockMarquee = document.querySelector(".clients-section .marquee");
  if (!clientsBlockMarquee) return;

  const root = document.documentElement;
  const marqueeElementDisplaed = getComputedStyle(root).getPropertyValue("--marquee-elements-displayed");
  const marqueeContent = document.querySelector(".clients-section .marquee__list");
  if (!marqueeContent) return;

  root.style.setProperty("--marquee-elements", marqueeContent.children.length);

  for (let i = 0; i < marqueeElementDisplaed; i += 1) {
    if (marqueeContent.children[i]) {
      marqueeContent.appendChild(marqueeContent.children[i].cloneNode(true));
    }
  }
}

runClientsMarquee();
